module.exports = __webpack_public_path__ + "img/paysuccess.94079aff.png";